import React, { Component } from 'react';
import DatePicker from 'react-date-picker';

import './CalendarDatePicker.css';

class CalendarDatePicker extends Component {

  handleOnChange = (date) => {
    const { name } = this.props;

    if (!!this.props.onChange) {
      this.props.onChange({
        [name]: date
      });
    }

    if (!!this.props.onDateChange) {
      this.props.onDateChange(date);
    }
  }

  render() {
    const { value, format = 'dd/MM/yyyy', calendarIcon, clearIcon = null, maxDate = new Date(), ...rest } = this.props;

    return (
      <div>
        <DatePicker
          format={ format }
          rangeDivider="&#8594;"
          showLeadingZeros={ true }
          value={ value }
          clearIcon={ clearIcon }
          calendarIcon={ calendarIcon }
          maxDate={ maxDate }
          { ...rest }
          onChange={ this.handleOnChange }
        />
      </div>
      );
    }
  }

export default CalendarDatePicker;